import { Outlet } from 'react-router-dom'

const Region = () => <Outlet />

export default Region
